const LocationType = Object.freeze({
  TERMINAL: 'Terminal',
  AIRPORT: 'Airport',
  SEAPORT: 'Seaport',
  RAILWAY_STATION: 'Railway Station',
  PICKUP_DELIVERY_ZONE: 'Pickup/Delivery Zone',
  CITY: 'City',
  COUNTRY: 'Country',
  REGION: 'Region'
})

const RoutePointTypes = Object.freeze({
  ORIGIN: 'origin',
  DESTINATION: 'destination'
})

const InternalPropertyDataTypes = Object.freeze({
  NUMBER: 'NUMBER',
  STRING: 'STRING',
  BOOLEAN: 'BOOLEAN',
  DATETIME: 'LocalDateTime',
  STRING_ARRAY: 'STRING[]',
  NUMBER_ARRAY: 'NUMBER[]'
})

const InternalPropertyDataTypesHumanReadable = Object.freeze({
  [InternalPropertyDataTypes.NUMBER]: 'Number',
  [InternalPropertyDataTypes.STRING]: 'String',
  [InternalPropertyDataTypes.BOOLEAN]: 'Boolean',
  [InternalPropertyDataTypes.DATETIME]: 'DateTime',
  [InternalPropertyDataTypes.STRING_ARRAY]: 'List of Strings',
  [InternalPropertyDataTypes.NUMBER_ARRAY]: 'List of Numbers'
})

const IncomingPropertyDataTypes = Object.freeze({
  FLOAT: 'FLOAT',
  INTEGER: 'INTEGER',
  STRING: 'STRING',
  BOOLEAN: 'BOOLEAN',
  DATETIME: 'LocalDateTime',
  STRING_ARRAY: 'String[]',
  LONG_ARRAY: 'long[]'
})

const RelationshpDirections = Object.freeze({
  INCOMING: 'INCOMING',
  OUTGOING: 'OUTGOING'
})

const EntityTypes = Object.freeze({
  NODE: 'node',
  RELATIONSHIP: 'relationship'
})

const Roles = Object.freeze({
  USER: 'user',
  MANAGER: 'manager',
  ADMIN: 'admin'
})

const OrderTypes = Object.freeze({
  CLIENT: 'client',
  AGENT: 'agent'
})

const OrderStatuses = Object.freeze({
  NEW: 'new',
  PENDING: 'pending'
})

export {
  LocationType,
  RoutePointTypes,
  InternalPropertyDataTypes,
  InternalPropertyDataTypesHumanReadable,
  IncomingPropertyDataTypes,
  RelationshpDirections,
  EntityTypes,
  Roles,
  OrderTypes,
  OrderStatuses
}



// WEBPACK FOOTER //
// ./src/enums.js